export default __webpack_public_path__ + "static/media/SG-White-0001.c6075c2a.png";